export const profile = {
  name: "Bhavika Aggarwal",
  title: "Software Engineer",
  heroSummary:
    "I focus on building reliable backend systems with strong performance and clear design—turning messy problems into simple, well-structured solutions. I’m especially drawn to distributed systems, microservices, and event-driven architectures.",
  resumeUrl:
    "https://drive.google.com/file/d/1n3-BxGPtmqEFY7DK4JHtFt6CcrAkZ5St/view?usp=sharing",
  social: {
    github: "https://github.com/Bhavika-14",
    linkedin: "https://www.linkedin.com/in/bhavika-aggarwal-963aaa221",
    email: "mailto:bhavikaagarwal2002@gmail.com",
  },
};
